module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/institutions/icon_course03-da6932d9a6e5ece00855646e343c1152.png";